"use client";

import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { handleGenerateProductLinkProps } from "@faire/retailer/components/Carousel/utils";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { ProductTileClickContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/ProductTileClickContext";
import { SearchProductTileClickProviderProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProviderProps";
import { useOnProductClickBase } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickBase";

export const LayoutElementProductTileClickBaseProvider = ({
  data: {
    productToken,
    impressionId,
    images,
    isPromoted,
    promotedBy,
    badgeList,
    brandToken,
    bestImage,
  },
  children,
}: {
  data: SearchProductTileClickProviderProps;
  children: ReactNode;
}) => {
  const { layoutElement, requestId, onItemClick } = React.useContext(Context);

  const onProductClickBase = useOnProductClickBase({
    token: productToken,
    isPromoted,
    impressionId,
    promotedBy,
    badgeList,
    bestImage,
    images,
  });
  const onProductClick = () => {
    onProductClickBase();
    onItemClick?.(
      layoutElement.on_click_event_name ?? "",
      requestId,
      productToken ?? ""
    );
  };
  const location = useLocation();
  const getProductLinkProps = handleGenerateProductLinkProps(
    ILeanProductTile.build({
      product: ILeanProductTile.ILeanProduct.build({
        token: productToken,
        brand_token: brandToken,
      }),
    }),
    location
  );
  const productLinkProps = getProductLinkProps();

  return (
    <ProductTileClickContext.Provider
      value={{ productLinkProps, onProductClick }}
    >
      {children}
    </ProductTileClickContext.Provider>
  );
};
